export class SurveyCustomerSmartWidgetConfigurationModel {
  id: number;
  start: string;
  end: string;
  customer_id: number;
  smartwidget_configuration_id: number;
  widget_uuid: string;
  partner_id: number;
  widget_step_id: number;
}
